<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (product(); as p) {
  <web-design-system-modal [headline]="p.name" (dismiss)="modal.close()">
    <div class="mb-3">
      <charts-web-trading-view-chart [model]="service.chart$ | async" [height]="260" (changePeriod)="service.changeChartPeriod($event)" />
    </div>
    <div class="mb-3 d-flex justify-content-between gap-half">
      <div class="flex-fill perf-card zero-surface grey-800 b-r-8 p-2">
        <div class="text-center zero-text p-xsmall-reg label">
          {{ 'investment-strategy.product-info-modal.perf-1-year' | transloco }}
        </div>
        @if (service.statistics$ | async; as statistics) {
          <div
            class="mt-2 text-center zero-text p-small-med"
            [class.text-color-success]="statistics.performanceCurrentYear >= 0"
            [class.text-color-error]="statistics.performanceCurrentYear < 0"
          >
            @if (statistics.performanceCurrentYear > 0) {
              +
            }
            {{ statistics.performanceCurrentYear | number: '1.2-2' }} %
          </div>
        } @else {
          <div class="text-color-primary">&mdash;</div>
        }
      </div>
      <div class="flex-fill perf-card zero-surface grey-800 b-r-8 p-2">
        <web-design-system-icon
          name="info"
          color="dimmed"
          size="medium"
          [ngbTooltip]="'investment-strategy.product-info-modal.ter-tooltip' | transloco"
        />
        <div class="text-center zero-text p-xsmall-reg label">
          {{ 'investment-strategy.product-info-modal.ter' | transloco }}
        </div>
        @if ((service.baseData$ | async)?.baseData; as baseData) {
          <div class="mt-2 text-center zero-text p-small-med">{{ baseData.ter | number }} %</div>
        } @else {
          <div class="text-color-primary">&mdash;</div>
        }
      </div>
    </div>
    <div class="mb-3 zero-text p-base-reg">{{ p.description }}</div>
    <a class="d-flex align-items-end gap-half" [href]="'https://www.finanzen.net/go/' + p.isin" target="_blank" rel="noopener noreferrer">
      <span class="zero-text p-base-reg link">{{ 'investment-strategy.product-info-modal.more' | transloco }}</span>
      <web-design-system-icon name="link-out" />
    </a>
  </web-design-system-modal>
}
